module.exports = "<h3 [ngClass]=\"getClass()\">{{ getStatusLabel() }}</h3>\n"